module.exports = __webpack_public_path__ + "img/cuir.eedc25e2.jpg";